import { create } from "zustand";
import { _get } from "nood-comp/src/net/xhr";
export var useSystemsStore = create(function (set) {
  return {
    systems: [],
    systems_for_dropdown: [],
    loadForDropdown: function loadForDropdown() {
      _get("/systems?for=dropdown", function (res) {
        set(function (state) {
          return {
            systems_for_dropdown: res.data
          };
        });
      });
    }
  };
});